import { useContext, useEffect, useState } from "react";
import { Table, Tooltip, Card, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

import { Context } from "../../context";
import { Fetch } from "../../fetch";

const { Column } = Table;

const LikesReports = () => {
  const { token, apiUrl } = useContext(Context);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    Fetch(`${apiUrl}/admins/analytics`, token, (result) => {
      if (result) {
        setData(result.data);
        setLoading(false);
        setRefresh(false);
      }
    });
  }, [apiUrl, token, refresh]);

  return (
    <div>
      <Card
        title="Likes Reports"
        extra={
          <div>
            <Tooltip title="Reload Report">
              <Button
                icon={<ReloadOutlined />}
                onClick={() => setRefresh(true)}
              />
            </Tooltip>
          </div>
        }
      >
        <Table dataSource={data} loading={loading} size="small">
          <Column
            title="Content Title"
            align="left"
            dataIndex={"title"}
            render={(_, record) =>
              record.title.length > 50 ? (
                <Tooltip title={record.title}>
                  <span>{`${record.title.slice(0, 50)}...`}</span>
                </Tooltip>
              ) : (
                record.title
              )
            }
          />
          <Column
            title="Likes"
            align="center"
            dataIndex={"likes"}
            render={(_, record) => (record.likes ? record.likes : 0)}
          />
        </Table>
      </Card>
    </div>
  );
};

export default LikesReports;
